export default __webpack_public_path__ + "static/media/nimbusTeamImage.11872d4d.png";